import * as React from "react";
import { FieldInputProps, FieldMetaState } from "react-final-form";

import { IPickerListItem, Picker } from "@livechat/design-system-react-components";

import { CustomFieldTypes } from "constants/custom-fields";

interface IProps {
  input: FieldInputProps<string, HTMLElement>;
  meta: FieldMetaState<string>;
  disabled: boolean;
  id: string;
}

export const CustomFieldTypeSelect: React.FC<IProps> = ({ input, meta, disabled, id }) => {
  const { value, onChange } = input;

  const options: IPickerListItem[] = [
    {
      key: CustomFieldTypes.SingleLine,
      name: "Single-line text",
    },
    {
      key: CustomFieldTypes.MultiLine,
      name: "Multi-line text",
    },
    {
      key: CustomFieldTypes.Url,
      name: "Link",
    },
    {
      key: CustomFieldTypes.Date,
      name: "Date",
    },
  ];

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleSelect = (selectedItems: IPickerListItem[] | null) => {
    if (!selectedItems) {
      return;
    }
    onChange(selectedItems[0].key);
  };

  return (
    <Picker
      id={id}
      options={options}
      disabled={disabled}
      placeholder="Choose custom field type"
      onSelect={handleSelect}
      selected={options.filter(option => option.key === value)}
      error={meta.modified ? meta.error : undefined}
      searchDisabled
      hideClearButton
    />
  );
};
